import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { SettingsResponse, SlackSettings } from '@/lib/types'

const SETTINGS_KEY = ['settings'] as const

export function useSettings(): ReturnType<typeof useQuery<SettingsResponse>> {
  return useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: () => apiClient.get<SettingsResponse>(endpoints.settings.get),
  })
}

export function useTestConnection(): ReturnType<
  typeof useMutation<{ ok: boolean }, unknown, void>
> {
  return useMutation({
    mutationFn: () => apiClient.post<{ ok: boolean }>(endpoints.settings.testConnection),
  })
}

export function useUpdateSlack(): ReturnType<typeof useMutation<unknown, unknown, SlackSettings>> {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (settings: SlackSettings) => apiClient.put(endpoints.settings.slack, settings),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: SETTINGS_KEY })
    },
  })
}

export function useTestSlack(): ReturnType<typeof useMutation<{ ok: boolean }, unknown, void>> {
  return useMutation({
    mutationFn: () => apiClient.post<{ ok: boolean }>(endpoints.settings.testSlack),
  })
}
